export default "__VITE_ASSET__4b4304d1__"